

import React from 'react'

function Subcontractor() {
  return (
    <div className='flex flex-col justify-center items-center'>
      <h1>Subcontractor Hello there</h1>
    </div>
  )
}

export default Subcontractor